(function (Drupal) {
  'use strict';

  Drupal.behaviors.bloc3ColonnesDestination = {
    attach: function (context, settings) {
      const carousels = context.querySelectorAll('.b3c-destination__wrapper .js-carousel');

      for (const carousel of carousels) {
        if (typeof Swiper === 'undefined') return;

        if (carousel.classList.contains('swiper-initialized') || carousel.swiper) continue;

        const isLoop = carousel.getAttribute('data-loop') === 'true';
        const wrapper = carousel.closest('.b3c-destination__wrapper');

        new Swiper(carousel, {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: isLoop,
          a11y: {
            enabled: true,
            prevSlideMessage: 'Slide précédente',
            nextSlideMessage: 'Slide suivante',
          },
          navigation: {
            nextEl: wrapper.querySelector('.swiper-button-next'),
            prevEl: wrapper.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: wrapper.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            576: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 32,
            },
          },
        });
      }
    }
  };
})(Drupal);
